<section class="padder flex-layout-row flex-layout-align-center-center">
  <mat-card class="flex-1400px flex-layout-column flex-100-lt-lg">
    <!-- desktop -->
    <mat-card-header>
      <div class="breadcrumbs">
        <app-breadcrumb [breadcrumbs]="breadCrumbs"></app-breadcrumb>
      </div>
    </mat-card-header>

    <mat-card-header
      class="flex-layout-row flex-layout-column-lt-md flex-layout-align-space-between-center flex-layout-align-start-stretch-lt-md"
    >
      <div fxFlex>
        <mat-card-title class="title-text">
          <h1>{{ 'marketplace.title' | translate }}</h1>
        </mat-card-title>
      </div>
      <div fxFlex fxLayoutGap.gt-sm="1%" fxLayoutAlign="end center">
        <div class="flex-layout-column">
          <div class="flex-layout-row">
            <p>{{ 'marketplace.toggle_label' | translate }}</p>
            <mat-slide-toggle
              id="availableProductToggleID"
              [(ngModel)]="onlyAvailable"
              [disabled]="buttonClicked"
              (toggleChange)="filterProducts_debounced()"
            ></mat-slide-toggle>
          </div>
          <mat-form-field
            fxFlex.lt-md="100%"
            appearance="outline"
            fxLayout.lt-md="column"
            subscriptSizing="dynamic"
          >
            <mat-label
              >{{ 'marketplace.search_placeholder' | translate }}</mat-label
            >
            <input
              matInput
              name="search"
              [(ngModel)]="namefilter"
              tabindex="1"
              (input)="filterProducts_debounced()"
            />
            <mat-icon matPrefix>search</mat-icon>
          </mat-form-field>
        </div>
      </div>
    </mat-card-header>

    <mat-card-content mat-align-tabs="center" class="mt-5x">
      <mat-tab-group
        mat-stretch-tabs
        [(selectedIndex)]="selectedTab"
        (selectedTabChange)="filterProducts_debounced()"
      >
        <mat-tab
          *ngFor="let tab of tabs; let i = index"
          label="{{ 'marketplace.class.' + tab.label | translate }}"
        >
        </mat-tab>
      </mat-tab-group>

      <ng-container class="products-container" #vc> </ng-container>

      <p class="no-products" *ngIf="filteredProducts?.length === 0">
        {{ 'marketplace.no_products' | translate }}
        <a href="tel://{{ 'marketplace.no_products_phone' | translate }}">
          {{ 'marketplace.no_products_phone' | translate }}
        </a>
      </p>

      <div
        id="pageLoaderID"
        *ngIf="!productsLoaded"
        fxLayoutAlign="center center"
      >
        <app-page-loader></app-page-loader>
      </div>
    </mat-card-content>
  </mat-card>
</section>

<ng-template #productsBatch let-productsBatch="items">
  <ng-container *ngFor="let product of productsBatch">
    <app-product-list-item
      [product]="product"
      [projects]="projects"
      [currentUser]="currentUser"
      [(buttonClicked)]="buttonClicked"
      (toggleNotification)="toggleProductNotification(product.id)"
    >
    </app-product-list-item>
  </ng-container>
</ng-template>
